
    import {defineComponent, reactive} from 'vue'

    interface State {
        isShowModel: boolean;
    }

    export default defineComponent({
        name: "checkDetail",
        setup() {
            let state: State = reactive({
                isShowModel: false,
            })
            return {
                state
            }
        },
        methods: {
            showModel() {
                this.state.isShowModel = true
                document.body.style.overflow = "hidden" 
            },
            hiddenModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            }
        }
    })
